import React, { Suspense } from 'react';

const Template1 = React.lazy(() => import('../templates/template_1/template_1'));
const Template2 = React.lazy(() => import('../templates/template_2/template_2'));
const Template3 = React.lazy(() => import('../templates/template_3/template_3'));
const Template4 = React.lazy(() => import('../templates/template_4/template_4'));
const Template5 = React.lazy(() => import('../templates/template_5/template_5'));
const Template6 = React.lazy(() => import('../templates/template_6/template_6'));
const Template7 = React.lazy(() => import('../templates/template_7/template_7'));
const Template8 = React.lazy(() => import('../templates/template_8/template_8'));
const Template9 = React.lazy(() => import('../templates/template_9/template_9'));

const TEMPLATE_MAP = {
  template_1: Template1,
  template_2: Template2,
  template_3: Template3,
  template_4: Template4,
  template_5: Template5,
  template_6: Template6,
  template_7: Template7,
  template_8: Template8,
  template_9: Template9,
};

export default function Dynamic({ value }) {
  const TemplateComponent = TEMPLATE_MAP[value?.selected_template];

  if (!TemplateComponent) return null;

  return (
    <Suspense fallback={null}>
      <TemplateComponent value={value} />
    </Suspense>
  );
}
